import React from 'react'
import { Badge, TakeAways, LazyLoad, SeoHelmet } from '../../common/Functions'
import Roles from './roles'
import Ecosystem from './ecosystem'

function Nac() {
  return (
   <div id="works">
    <SeoHelmet title="NAC CMC-OMT" description="A web application that captures the fleet and operation data entries and generates reports for a mining company - Nickel Asia Corporation Cagdianao Mining Corporation." />
    <section className="banner nac px-0">
      <div className="max-w-screen-xl	mx-auto">
        <main className="mt-10">
          <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
            <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0 mt-10">
              <div className="content">
                <h1 className="text-left font-bold text-3xl text-white">
                  A web application that captures the fleet and operation data entries and generates reports for a mining company - Nickel Asia Corporation Cagdianao Mining Corporation.
                </h1>
                <p className="text-white mt-10">
                  See how I help to develop an operational management tool for NAC CMC administrators and encoders.
                </p>
                <div className="roles mt-20">
                  <Badge title="Project Manager" />
                  <Badge title="UX/UI Design" />
                  <Badge title="Web Application" />
                </div>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full sm:order-first md:order-first lg:order-last flex items-center justify-center">
              <LazyLoad className="inline h-auto w-48" src={require('../../common/images/home/nac.png')} alt="NAC Logo" />
            </div>
          </div>
        </main>
      </div>
      </section>
      <Roles />
      <Ecosystem />
      <TakeAways content="This project is one of the early times I applied my learnings as a UI/UX Designer that comes with excellent output. To start with, I used to do my previous web design projects with Adobe Illustrator or Photoshop, and then I discovered how to maximize my skills using Adobe XD and applied it to this project. I also utilized my abilities to deeply understand the manual process and transform it into an automated process solution. Through this experience, it became the start of my journey as a UI/UX Designer." />
   </div>
  )
}

export default Nac
